module.exports = __webpack_public_path__ + "static/Celia_Seba-9eee7a340a7f1a6fc215572b343dd912.png";